import { Loader2, Mic, Square, Volume2, VolumeX, Play } from "lucide-react";

export const MicButton = ({ state, seconds, max, onStart, onStop, disabled }) => {
  if (state === "recording") return (
    <button type="button" onClick={onStop} className="relative mm-btn !px-4 !bg-mm-error shrink-0" aria-label="Stop and send" data-testid="ai-mic-stop">
      <span className="absolute inset-0 rounded-full animate-ping bg-mm-error/40" aria-hidden />
      <Square size={16} className="relative" /><span className="relative text-xs tabular-nums" data-testid="ai-mic-timer">{max - seconds}s</span>
    </button>
  );
  if (state === "transcribing") return <button type="button" className="mm-btn-ghost !px-4 shrink-0" disabled aria-label="Turning speech into text" data-testid="ai-mic-busy"><Loader2 size={18} className="animate-spin" /></button>;
  return <button type="button" onClick={onStart} disabled={disabled} className="mm-btn-ghost !px-4 shrink-0" aria-label="Talk to Mia" data-testid="ai-mic-button"><Mic size={18} /></button>;
};

export const VoiceToggle = ({ enabled, onToggle }) => (
  <button className="mm-btn-ghost !px-3 text-sm whitespace-nowrap" onClick={onToggle} aria-pressed={enabled} aria-label={`Voice replies ${enabled ? "on" : "off"}`} title={`Voice replies ${enabled ? "on" : "off"}`} data-testid="ai-voice-toggle">
    {enabled ? <Volume2 size={16} /> : <VolumeX size={16} />}<span className="hidden sm:inline">Voice {enabled ? "on" : "off"}</span>
  </button>
);

const Wave = () => (
  <span className="inline-flex items-end gap-0.5 h-3" aria-hidden>
    {[0, 1, 2, 3].map((i) => <span key={i} className="w-0.5 bg-mm-primary rounded-full animate-pulse" style={{ height: `${6 + (i % 2) * 6}px`, animationDelay: `${i * 120}ms` }} />)}
  </span>
);

export const ReplayButton = ({ id, playing, loading, onPlay, onStop }) => {
  if (loading) return <span className="text-xs text-mm-muted inline-flex items-center gap-1 mt-1" data-testid={`ai-voice-loading-${id}`}><Loader2 size={12} className="animate-spin" />Getting Mia's voice…</span>;
  if (playing) return (
    <button onClick={onStop} className="text-xs text-mm-primary font-medium inline-flex items-center gap-1.5 mt-1" data-testid={`ai-voice-stop-${id}`}><Wave />Speaking · Stop</button>
  );
  return <button onClick={onPlay} className="text-xs text-mm-muted hover:text-mm-primary inline-flex items-center gap-1 mt-1" data-testid={`ai-voice-play-${id}`}><Play size={12} />Play</button>;
};
